import React, { useEffect } from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import { get as getConfig } from 'config'
import _get from 'lodash/get'
import { Map } from 'immutable'
import { getBoundActions } from 'actions'
import { getClassName, shouldRenderFeature } from './utils'

const config = getConfig()

function OptimizelyFeature (props) {
  const {
    flag,
    children,
    noWrapper,
    variation,
    isDefault,
    setOptimizelyFeatureMounted,
    setOptimizelyFeatureFlag,
  } = props

  const optimizelyFeatureTesting = !!_get(config, ['features', 'optimizelyFeatureTesting'])
  const shouldRender = shouldRenderFeature(props)
  const renderDefault = !optimizelyFeatureTesting && isDefault
  const classes = getClassName(variation)

  useEffect(() => {
    if (optimizelyFeatureTesting) {
      setOptimizelyFeatureMounted(true)
      setOptimizelyFeatureFlag(flag)
    }

    return () => {
      setOptimizelyFeatureMounted(false)
    }
  }, [])

  if (!shouldRender && !renderDefault) return null

  if (noWrapper || renderDefault) {
    return <>{children}</>
  }

  return (
    <div className={classes}>
      {children}
    </div>
  )
}

OptimizelyFeature.propTypes = {
  flag: PropTypes.string.isRequired,
  children: PropTypes.node,
  variation: PropTypes.string.isRequired,
  noWrapper: PropTypes.bool,
  isDefault: PropTypes.bool,
  optimizelyFeature: PropTypes.object,
  setOptimizelyFeatureMounted: PropTypes.func,
  setOptimizelyFeatureFlag: PropTypes.func,
}

OptimizelyFeature.defaultProps = {
  isDefault: false,
  noWrapper: false,
}

export default compose(
  connectRedux(
    (state) => ({
      optimizelyFeature: state.optimizelyFeature || Map(),
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setOptimizelyFeatureMounted: actions.optimizelyFeature.setOptimizelyFeatureMounted,
        setOptimizelyFeatureFlag: actions.optimizelyFeature.setOptimizelyFeatureFlag,
      }
    },
  ),
)(OptimizelyFeature)
